export interface ICaseDetailsModel {
  caseId: string;
  caseCode: string;
  title: string;
  assignTo: string | null;
  caseType: string | null;
  lor: string | null;
  notes: string | null;
  dueDate: string;
  status: CaseStatusEnum | string;
  createdDate: string | null;
  createdBy: string | null;
  updatedDate: string | null;
  updatedBy: string | null;
  statusChangedDate: string | null;
  dueDays: number;
  daysInStatus: number | null;
  companyName: string | null;
  caseManager: string;
  caseCreator: string;
  lorName: string | null;
  caseTask: ICaseTaskModel[] | [];
  caseDocuments: [];
  caseNotifications: ICaseTaskNotificationModel[];
}

export interface ICaseTaskModel {
  taskId: string;
  title: string | null;
  assignedTo: string | null;
  type: CaseTaskEnum | string; // Todo: remove string
  dueDate: string | null;
  status: TaskStatusEnum;
  createdBy: string | null;
  description: string | null;
  createdDate: string | null;
  updatedBy: string | null;
  updatedDate: string | null;
  taskManager: string | null;
  noOfPredecessors: number;
  isDueDateValid: string | null;
  dueDateErrorMessage: string | null;
  caseNotifications: ICaseTaskNotificationModel[];
  casePrePostTaskDetailsList: ICaseTaskDetailsList[];
  taskTodo: {
    todoUuid: string;
    taskId: string;
    todoNotes: string | null;
    manualTodoDocList: ICaseTaskDocumentModel[];
  };
}

export interface ICaseTaskDocumentModel {
  documentId: string;
  documentName: string;
  documentPath: string | null;
  todoUuid: string | null;
}

export interface ICaseTaskNotificationModel {
  caseNotificationId: string;
  caseId: string;
  taskId: string | null;
  type: CaseNotificationsEnum;
  userId: string;
  createdDate: string | null;
  createdBy: string | null;
  userName: string | null;
}

export interface ICaseStatusModel {
  heading: string;
  value: string[];
}

export interface IAddCaseInput {
  caseId: string;
  comment: string;
  commentId?: string;
  createdBy?: string;
  updatedBy?: string;
  userId?: string[];
}

export enum CaseStatusEnum {
  NEW_CASE = "New Case",
  IN_PROCESS = "In-Process",
  IN_REVIEW = "In Review",
  CLOSED = "Closed",
  DUE_DATE_NEAR = "Due Date Near",
  OVERDUE = "Overdue",
  ARCHIVED = "ARCHIVED",
  PRELIMINARY = "Preliminary",
  READY_FOR_REVIEW = "READY_FOR_REVIEW",
  SUBMITTED = "SUBMITTED",
}

export enum CaseTaskEnum {
  KICK_OFF_TASK = "Kick_Off_Task",
  TASK = "Task",
  CLOSING_TASK = "Closing_Task",
}

export enum TaskStatusEnum {
  INACTIVE = "Inactive",
  TO_DO = "To-Do",
  IN_PROGRESS = "In_Progress",
  COMPLETED = "Completed",
}

export enum CasePrePostEnum {
  PREDECESSOR = 0,
  SUCCESSOR = 1,
}

export enum CaseNotificationsEnum {
  DUE = 0,
  COMPLETION = 1,
}

export interface ICaseTaskInput {
  caseId: string;
  type: CaseStatusEnum;
  title: string;
  assignedTo: string;
  description: string;
  dueDate: string;
  predecessorTo: string[];
  successorTo: string[];
  reachingDueDateNotificatonId: [];
  completionNotificationId: [];
}

export interface IEditCaseTaskInput extends ICaseTaskInput {
  taskId: string;
}

export interface ICaseTaskHistoryModel {
  taskId: string;
  taskInfo: string;
  createdByName: string;
  createdDate: string;
  taskHistoryId: string;
}

export interface ICaseTaskDetailsList
  extends Pick<ICaseTaskModel, "title" | "taskId"> {
  type: CasePrePostEnum;
}

export interface ICaseDocumentModel {
  caseDocMappingId: string;
  caseId: string;
  createdBy: string;
  createdDate: string;
  documentName: string;
  documentUrl: string;
  status: string;
}

export interface ICaseCommentModel {
  caseCommentId: string;
  comment: string;
  createdBy: string;
  createdDate: string;
  updatedDate: string;
  name: string;
  status: string;
  userId?: string[];
}
